import React from "react";
import './footer.css';
import {BsLinkedin} from 'react-icons/bs';
import {BsGithub} from 'react-icons/bs';
import {FaInstagramSquare} from 'react-icons/fa';

function Footer() {
    return(
        <footer>
            <div className="footer__content">
                <small>&copy; Marwan Osman. All Rights Reserved.</small>
                <div className='line'></div>
                <div className="socials">
                    <a href="https://www.instagram.com/marwan_0sman/" target="_blank"><FaInstagramSquare/></a>
                    <a href="https://www.linkedin.com/in/marwan-osman-5b9b88209/" target="_blank"><BsLinkedin /></a>
                    <a href="https://github.com/marwanosman505" target="_blank"><BsGithub/></a>

                </div>

            </div>
        </footer>
    )
}

export default Footer;